import type { DayElement } from 'flatpickr/dist/types/instance';
import { between } from '@holiday-jp/holiday_jp';

/**
 * flatpickr の onDayCreate で祝日をマークする共通ハンドラ
 */
export function onDayCreateHoliday(
    _dObj: Date[],
    _dStr: string,
    _fp: unknown,
    dayElem: DayElement,
): void {
    const date = dayElem.dateObj;
    if (!date) return;
    const holidays = between(date, date);
    if (holidays.length === 0) return;
    dayElem.classList.add('flatpickr-day--holiday');
    dayElem.dataset.tip = holidays[0].name;
}

export type SlotsPanelResult = {
    panel: HTMLElement;
    wrapper: HTMLElement;
};

/**
 * 時間スロットパネルを構築して返す。
 * onSelect(time) はスロット選択時に呼ばれるコールバック。
 */
export function buildTimeSlotsPanel(
    times: string[],
    title: string,
    onSelect: (time: string) => void,
): SlotsPanelResult {
    const panel = document.createElement('div');
    panel.className = 'flatpickr-slots-panel';

    if (title) {
        const titleEl = document.createElement('div');
        titleEl.className = 'flatpickr-slots-title';
        titleEl.textContent = title;
        panel.appendChild(titleEl);
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'flatpickr-time-slots';

    times.forEach((time, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'flatpickr-time-slot';
        if (i === 0) btn.classList.add('is-selected');
        btn.textContent = time;
        btn.dataset.time = time;

        btn.addEventListener('click', () => {
            wrapper.querySelectorAll('.flatpickr-time-slot').forEach((b) =>
                b.classList.remove('is-selected'),
            );
            btn.classList.add('is-selected');
            onSelect(time);
        });

        wrapper.appendChild(btn);
    });

    panel.appendChild(wrapper);
    return { panel, wrapper };
}
